// extracted by mini-css-extract-plugin
export default {"link":"account-wishlist-link--1594d","container":"account-wishlist-container--cc46e","icon":"account-wishlist-icon--83b5d","desktop":"account-wishlist-desktop--627a7"};